import { useEffect, useState } from 'react';
import { fetchSettings } from '../api/settingsApi';

const PAYMENT_KEYS = [
  'payment.recipient',
  'payment.iban',
  'payment.edrpou'
];

export const usePaymentSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchSettings(PAYMENT_KEYS)
      .then(data => {
        setSettings({
          recipient: data['payment.recipient'],
          iban: data['payment.iban'],
          edrpou: data['payment.edrpou']
        });
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return {
    settings,
    loading,
    error
  };
};
